<template>
    <mask-input v-bind="[$attrs, $props]"
                :value="value"
                :mask="mask"
                :lazy="false"
                :unmask="true"
                autofocus="on"
                @accept="accept" />
</template>

<script>
    import { IMaskComponent as maskInput } from "vue-imask";

    export default {
        components: { maskInput },
        props: {
            value: { type: String },
            mask: { type: String, required: true }
        },
        methods: {
            async accept(value) {
                this.$emit("input", value);
            }
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/phone-number/phone-number-masked.vue